// 评论管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/CommunityManager/getCommentList", data);

// 删除
export const del = (data) => http.post("/web/CommunityManager/deleteComment", data);

// 详情
export const detail = (data) => http.post("/web/CommunityManager/getCommentDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/CommunityManager/commentStatusUpdate", data);